import { render, staticRenderFns } from "./redpacket.vue?vue&type=template&id=f59df686&scoped=true&"
import script from "./redpacket.vue?vue&type=script&lang=js&"
export * from "./redpacket.vue?vue&type=script&lang=js&"
import style0 from "./redpacket.vue?vue&type=style&index=0&id=f59df686&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f59df686",
  null
  
)

export default component.exports